import React, { useContext } from "react";
import AppMessages from "../AppMessages";
import { ThemeContext } from "../../container/mppmodal/MppInfo";

const PendingStatusPage = () => {
  const { merchantName } = useContext(ThemeContext);

  let pendingMsg1 = AppMessages.pendingMsg1;
  let pendingMsg2 = AppMessages.pendingMsg2;
  pendingMsg2 = pendingMsg2.replace("[MERCHANT_NAME]", merchantName);
  let pendingMsg3 = AppMessages.pendingMsg3.split("Credit Card");
  let pendingMsg3_1 = pendingMsg3[0];
  let pendingMsg3_2 = pendingMsg3[1];
  let pendingMsg4 = AppMessages.pendingMsg4.split("SetPay installment");
  let pendingMsg4_1 = pendingMsg4[0];
  let pendingMsg4_2 = pendingMsg4[1];
  if (document.location.href.indexOf("source=mppCheckout") >= 0) {
    window.parent.postMessage("destroy-syf-session", "*");
  }
  return (
    <div className="queryBlock">
      <p>
        {pendingMsg1}
        <br />
        <br />
        {pendingMsg2}
        <br />
        <br />
        <div>
          {pendingMsg4_1}
          <b>SetPay installment</b>
          {pendingMsg4_2} <br />
          <br />
          {pendingMsg3_1}
          <b>Credit Card</b>
          {pendingMsg3_2}
        </div>
      </p>
    </div>
  );
};
export default PendingStatusPage;
